import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';

import {
  deleteQuickResponse,
  searchQuickResponse,
  openQuickResponseDelete,
  clearRedux
} from 'Redux/actions';


const QuickDelete = (props) => {
  const dispatch = useDispatch();
  const { callBack } = props;
  const { messages } = useIntl();


  const {
    openDelete,
    quickResponseDelete,
    responseDelete,
    loadingDelete
  } = useSelector((state) => state.quickResponseRedux);



  useEffect(() => {
    if (responseDelete === true) {
      NotificationManager.success(
        messages['FSM_SETTINGS_QUICK_RESPONSE_delete_success'],
        messages['success'],
        3000,
        null,
        null,
        'Success',
      );
      dispatch(clearRedux("FSM_SETTINGS_QUICK_RESPONSE", {
        responseDelete: false
      }));
      handleClose();
    }
  }, [responseDelete]);


  const handleClose = useCallback(() => {
    dispatch(clearRedux("FSM_SETTINGS_QUICK_RESPONSE", {
      responseDelete: false
    }));
    dispatch(searchQuickResponse());
    callBack();
    dispatch(openQuickResponseDelete(false, []));
  });

  return (
    <Modal
      title={messages["FSM_SETTINGS_QUICK_RESPONSE_delete_title"]}
      open={openDelete}
      position="right"
      size="small"
      className="modal-top-0"
      headerStyle={{
        top: 0
      }}
      handleClose={handleClose}
    >
      <ModalBody>
        <div style={{ padding: '18px 24px 24px 24px', height: 650 }}>

          <div>
            <p>
              {messages["FSM_SETTINGS_QUICK_RESPONSE_delete_detail"]}
            </p>
            <p>
              {messages["FSM_SETTINGS_QUICK_RESPONSE_delete_warning"]}
            </p>
          </div>

          <div style={{ padding: 10 }}>
            <ul>
              {
                quickResponseDelete
                &&
                quickResponseDelete.map((QuickResponse, index) => {
                  return (
                    <li key={index}>
                      <span>{QuickResponse.name}</span>
                    </li>
                  )
                })
              }
            </ul>
          </div>

        </div>
      </ModalBody>

      <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }} >
        <Button
          disabled={loadingDelete}
          onClick={handleClose}
          className="btn-cancel"
        >
          {messages['cancel']}
        </Button>

        <Button
          disabled={loadingDelete}
          onClick={(e) => {
            if (e) e.preventDefault();

            dispatch(deleteQuickResponse(quickResponseDelete));
          }}
          className="btn-red"
        >
          {messages['delete']}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default QuickDelete;